export const CHAT_ERROR_PREFIX = "⚠️ Error: ";

export function formatChatError(errorMessage: string): string {
  return `${CHAT_ERROR_PREFIX}${errorMessage}`;
}

export function parseChatError(text: string): string | null {
  return text.startsWith(CHAT_ERROR_PREFIX)
    ? text.slice(CHAT_ERROR_PREFIX.length)
    : null;
}
